/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserSigninVerifyRequest = {
  properties: {
    email: {
      type: 'string',
    },
    phone: {
      type: 'string',
    },
    type: {
      type: 'SigninType',
      isRequired: true,
    },
    verificationCode: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
